var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},_vm._l((_vm.maxRating),function(index){return _c('div',{key:index,staticClass:"mx-1 cursor-pointer",on:{"click":function($event){return _vm.setValue(index - 1)}}},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'heartbeat'],"color":_vm.getColor(index - 1),"size":"2x"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }